import { useAppUser } from '../auth/AppUserContext';
import type { AppUser, Store } from '../data/types';

/**
 * A store team that sees exactly one store — its own (UI review 3, S8 / U12):
 * every card on its Home, Audits, Tasks and store pages is that store, so the
 * store, district and "assigned to <the store>" only repeat. Pure.
 */
export function isOwnStoreOnly(user: AppUser | null | undefined, store: Store | null | undefined): boolean {
  if (!user || !store || user.role !== 'StoreTeam') return false;
  if (user.districts.length > 0 || user.storeNumbers.length !== 1) return false;
  return user.storeNumbers[0]!.trim() === store.storeNumber.trim();
}

/** `isOwnStoreOnly` for the signed-in (effective) user. */
export function useOwnStoreOnly(store: Store | null | undefined): boolean {
  return isOwnStoreOnly(useAppUser().user, store);
}
